// store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducers from "./rootReducers";
import API from "../api/baseApi";

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducers);

const store = configureStore({
  reducer: persistedReducer,
});

const { token } = store.getState().auth;
const { selectedClient } = store.getState().clients;

API.interceptors.request.use(
  (config) => {
    console.log(token, "token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (selectedClient) {
      config.headers["x-tenant-id"] = selectedClient;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const persistor = persistStore(store);

export { store };
